import { NUMBER_FORMAT_LOCALE } from '@shared/consts/i18n.ts';

export const createNumberFormat = (options: Intl.NumberFormatOptions = {}) =>
  new Intl.NumberFormat(NUMBER_FORMAT_LOCALE, options);

const createGroupedNumberFormat = (options: Intl.NumberFormatOptions = {}) =>
  createNumberFormat({ useGrouping: 'always', ...options });

const groupedNumberFormat = createGroupedNumberFormat();
const compactNumbersFormat = createNumberFormat({ notation: 'compact' });
const plainThousandsFormat = createNumberFormat({ useGrouping: 'min2', maximumFractionDigits: 0 });
const numberWithMaxTwoDigits = createGroupedNumberFormat({ maximumFractionDigits: 2 });
const numberWithMinOneDigit = createGroupedNumberFormat({ minimumFractionDigits: 1 });
const numberWithZeroDigit = createGroupedNumberFormat({ maximumFractionDigits: 0 });

export function formatNumberWithCommas(n: number) {
  return groupedNumberFormat.format(n);
}

export function formatNumberWithCommasInteger(n: number) {
  return numberWithZeroDigit.format(n);
}

export function formatNumbersAsCompactNumbers(n: number) {
  // ICU 78 compacts Italian thousands to "1K"; keep the full number as earlier ICU versions did
  const isThousands = Math.abs(n) >= 1000 && Math.abs(n) < 1000000;
  return isThousands ? plainThousandsFormat.format(n) : compactNumbersFormat.format(n);
}

export function formatNumberWithMaxTwoDigitsAfterSeparator(n: number) {
  return numberWithMaxTwoDigits.format(n);
}

export function formatNumberWithMinOneDigitAfterSeparator(n: number) {
  return numberWithMinOneDigit.format(n);
}
